import { Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

interface ISectionTitleProps {
  label: string;
  raw?: boolean;
}

function SectionTitle({ label, raw }: ISectionTitleProps) {
  const translate = useTranslate();

  return (
    <Typography variant="h6" gutterBottom>
      {raw ? label : translate(label as string)}
    </Typography>
  );
}

export default SectionTitle;
